export const VIEWPORT_WL_EFFECTIVE_DEFAULT_MARKER = 'KAIROS_QOL_VIEWPORT_WL_EFFECTIVE_DICOM_DEFAULT';

const finiteNumber = (value) => {
  const raw = value?.Value ?? value;
  const first = Array.isArray(raw) ? raw[0] : raw;
  const n = Number(first);
  return Number.isFinite(n) ? n : null;
};

const readFirst = (source, keys) => {
  for (const key of keys) {
    if (source && Object.prototype.hasOwnProperty.call(source, key)) return source[key];
  }
  return undefined;
};

export const normalizeViewportWindowLevel = (wl = {}) => {
  const rawWw = finiteNumber(wl?.ww ?? wl?.windowWidth ?? wl?.WindowWidth ?? wl?.window_width ?? wl?.width);
  const rawWc = finiteNumber(wl?.wc ?? wl?.windowCenter ?? wl?.WindowCenter ?? wl?.window_center ?? wl?.center);
  const ww = rawWw == null ? 0 : Math.max(0, Math.min(9999, Math.round(rawWw)));
  const wc = rawWc == null ? 0 : Math.max(-9999, Math.min(9999, Math.round(rawWc)));
  return {
    ww,
    wc,
    source: wl?.source || (ww > 0 ? 'manual' : 'auto'),
  };
};

export const formatWindowLevelDraft = (wl) => {
  const normalized = normalizeViewportWindowLevel(wl);
  return { ww: String(normalized.ww), wc: String(normalized.wc) };
};

export const describeWindowLevelOverlay = (wl) => {
  const normalized = normalizeViewportWindowLevel(wl);
  return normalized.ww > 0 ? `WW:${normalized.ww} WC:${normalized.wc}` : 'WW/WL: Auto';
};

export const getDicomWindowLevelFromGeometry = (geometry = []) => {
  const frames = Array.isArray(geometry) ? geometry : [geometry];
  for (const frame of frames) {
    const ww = finiteNumber(readFirst(frame, ['windowWidth', 'WindowWidth', 'window_width', 'ww']));
    const wc = finiteNumber(readFirst(frame, ['windowCenter', 'WindowCenter', 'window_center', 'wc']));
    if (ww != null && ww > 0 && wc != null) {
      return normalizeViewportWindowLevel({ ww, wc, source: 'dicom-default' });
    }
  }
  return null;
};

export const resolveEffectiveDefaultWindowLevel = ({ initialWL = null, geometry = null } = {}) => {
  const normalizedInitial = initialWL ? normalizeViewportWindowLevel({ ...initialWL, source: initialWL.source || 'protocol-default' }) : null;
  if (normalizedInitial && normalizedInitial.ww > 0) return normalizedInitial;
  const dicomDefault = getDicomWindowLevelFromGeometry(geometry);
  if (dicomDefault) return dicomDefault;
  return normalizeViewportWindowLevel({ ww: 0, wc: 0, source: 'auto' });
};
